<header>
  <button mat-icon-button aria-label="閉じる" (click)="onClose()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
  <ng-content></ng-content>
</header>
